import percentChanged from "../../../../components/percentChanged/percentChanged";
import { connect } from "react-redux";
export default connect(state => ({
  changeValue: state.revenue.allRevenues.totalRevenueMTMChange,
  currencySymbol: state.revenue.allRevenues.currencySymbol,
  toolTip: "Percentage change from previous month",
  showBorder: true
}))(percentChanged);
